import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Logo.svg'
import _imports_1 from '@/assets/工作台.fd407ffa.svg'
import _imports_2 from '@/assets/icon-svg/source/1-查找.svg'
import _imports_3 from '@/assets/icon-svg/source/2-帮助.svg'
import _imports_4 from '@/assets/icon-svg/source/3-消息.svg'
import _imports_5 from '@/assets/icon-svg/source/3-hasUnread消息.svg'


const _hoisted_1 = { class: "left-bar" }
const _hoisted_2 = { class: "left-bar-menu" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "left-bar-menu-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "left-bar-menu-subtitle" }, "普乐师", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "obnoxious",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"8px","font-size":"12px","color":"#008bcf","line-height":"20px","font-weight":"400"} }, "控制台", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "search-bar" }
const _hoisted_9 = { class: "right-bar" }
const _hoisted_10 = { class: "right-bar-list" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "anticon-self obnoxious",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "anticon-self obnoxious",
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "iam-text-style" }
const _hoisted_15 = { class: "iam-text-style" }
const _hoisted_16 = {
  key: 0,
  class: "anticon-self obnoxious",
  src: _imports_4,
  alt: ""
}
const _hoisted_17 = {
  key: 1,
  class: "anticon-self obnoxious",
  src: _imports_5,
  alt: ""
}
const _hoisted_18 = { class: "item-body-user" }
const _hoisted_19 = { class: "HeaderUserInfo" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "用户名称：", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "margin-top-self-20" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "认证状态：", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "margin-top-self-20" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "margin-top-self-40" }, null, -1)
const _hoisted_25 = { style: {"text-align":"center"} }
const _hoisted_26 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_SafetyCertificateOutlined = _resolveComponent("SafetyCertificateOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_Header = _resolveComponent("Header", true)!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, {
    style: {"padding-top":"60px"},
    class: "basicsHeader"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Header, { class: "header" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("div", {
                class: "left-bar-menu-dashboard",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toDashBoard && _ctx.toDashBoard(...args)))
              }, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            false
              ? (_openBlock(), _createBlock(_component_a_input, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createVNode(_component_a_button, { type: "link" }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_a_button, { type: "link" }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_a_button, { type: "link" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_popover, {
                      placement: "bottomRight",
                      trigger: "hover"
                    }, {
                      content: _withCtx(() => [
                        _createVNode(_component_a_list, {
                          class: "header-message",
                          bordered: "",
                          "data-source": this.$store.state.newMessages
                        }, {
                          renderItem: _withCtx(({ item }) => [
                            _createVNode(_component_a_list_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "list-item-body",
                                  onClick: ($event: any) => (_ctx.toPath(1, item))
                                }, [
                                  _createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1),
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.createdAt ? item.createdAt : "-"), 1)
                                ], 8, _hoisted_13)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          header: _withCtx(() => [
                            _createTextVNode("消息通知")
                          ]),
                          footer: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toPath(0, null)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("查看更多")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ]),
                      default: _withCtx(() => [
                        (
                    !this.$store.state.newMessages ||
                    this.$store.state.newMessages.length <= 0
                  )
                          ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                          : (_openBlock(), _createElementBlock("img", _hoisted_17))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_a_popover, {
                  placement: "bottomRight",
                  defaultVisible: false,
                  trigger: "hover"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_row, {
                        gutter: 0,
                        type: "flex",
                        justify: "start",
                        align: "middle"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 5 }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 18 }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(this.$store.state.userInfo.name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _hoisted_21,
                      _createVNode(_component_a_row, {
                        gutter: 0,
                        type: "flex",
                        justify: "start",
                        align: "middle"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 5 }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 18 }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(this.$store.state.userInfo.authc_status
                          ? "已认证"
                          : "待认证"), 1),
                              (!this.$store.state.userInfo.authc_status)
                                ? (_openBlock(), _createBlock(_component_a_button, {
                                    key: 0,
                                    type: "link",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toCertUrl(0)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" [" + _toDisplayString("立即认证") + "] ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_divider),
                      _hoisted_23,
                      _createVNode(_component_a_row, {
                        gutter: 15,
                        type: "flex",
                        justify: "center",
                        align: "middle"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                style: {"border-color":"#008bcf","color":"#008bcf"},
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toCertUrl(1)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_UserOutlined),
                                  _createTextVNode("基本信息 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                style: {"border-color":"#008bcf","color":"#008bcf"},
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toCertUrl(2)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_SafetyCertificateOutlined),
                                  _createTextVNode("安全设置")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                style: {"border-color":"#008bcf","color":"#008bcf"},
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toCertUrl(3)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_SafetyCertificateOutlined),
                                  _createTextVNode("认证管理")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_a_button, {
                          loading: this.$store.state.loadingStatus,
                          onClick: _ctx.loginOut,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 退出登录 ")
                          ]),
                          _: 1
                        }, 8, ["loading", "onClick"])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_avatar, {
                      size: 40,
                      src: this.$store.state.userInfo.avatar,
                      class: "obnoxious"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_UserOutlined)
                      ]),
                      _: 1
                    }, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "item-user-info",
                  title: this.$store.state.userInfo.nickname
                }, _toDisplayString(this.$store.state.userInfo.nickname), 9, _hoisted_26)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}